const CommonButtonNew = ({
   btnText,
   onClick = () => {},
   loading = false,
   id = "new-btn",
   isWhiteBtn,
   isbuttonWidth,
   buttonWidth,
}) => {
   return (
      <button
         id={id}
         onClick={onClick}
         style={{ width: isbuttonWidth && `${buttonWidth}` }}
         className={`pg-comman-button-new-ui ${isWhiteBtn ? " pg-blue-button-new-ui " : "pg-white-button-new-ui"}`}
      >
         {loading ? <div style={{ width: "2.5rem", height: "2.5rem" }} className="spinner-border"></div> : btnText}
      </button>
   );
};

export default CommonButtonNew;
